/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Form, FormGroup, Input, Label, Spinner, Button } from 'reactstrap';
import DeleteModal from '~/components/DeleteModal';

import { Container } from './styles';

function UpdateCard({
  groupData,
  handleUpdate,
  setForm,
  form,
  loading,
  handleDelete,
}) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Container>
      <h1>Atualizar dados do grupo: {groupData.nome}</h1>
      <Form onSubmit={handleUpdate} style={{ width: '100%' }}>
        <FormGroup>
          <Label>Nome do grupo</Label>
          <Input
            type="text"
            name="nome"
            defaultValue={groupData.nome}
            placeholder="Insira o nome"
            onChange={(e) => {
              setForm({ ...form, groupName: e.target.value });
            }}
          />
        </FormGroup>
        <FormGroup tag="fieldset">
          <Label>Situação cadastral</Label>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="radio1"
                onChange={() => setForm({ ...form, situacaoCadastral: 1 })}
                defaultChecked={groupData.idSituacaoCadastral === 1}
              />
              Ativo
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="radio1"
                onChange={() => setForm({ ...form, situacaoCadastral: 2 })}
                defaultChecked={groupData.idSituacaoCadastral !== 1}
              />
              Inativo
            </Label>
          </FormGroup>
        </FormGroup>
        {loading ? (
          <section>
            <Button color="primary" disabled className="btn2">
              <Spinner size="sm" color="#FFF" />
            </Button>
            <Button color="danger" disabled className="btn1">
              <Spinner size="sm" color="#FFF" />
            </Button>
          </section>
        ) : (
          <section>
            <Button color="primary" onClick={handleUpdate} className="btn2">
              Atualizar
            </Button>
            <Button color="danger" outline onClick={toggle} className="btn1">
              Excluir
            </Button>
          </section>
        )}
      </Form>

      <DeleteModal
        toggle={toggle}
        modal={modal}
        handleDelete={handleDelete}
        id={groupData.id}
        loading={loading}
      />
    </Container>
  );
}

export default UpdateCard;
